<template>
<div class="last-projects">
    <h2 class="mb-8">Mes derniers projets</h2>
    <div class="container">
        <Loader v-if="loading"/>
        <div v-else class="projets-wrapper">
            <div class="last-projects__iframe">
                <iframe
                title="Showreel Pauline FUCHS 2025"
                src="https://player.vimeo.com/video/477701835"
                width="1200"
                height="675"
                frameborder="0"
                allow="autoplay; fullscreen" ></iframe>
            </div>
          <ul class="last-projects__list animate__animated animate__zoomIn"  >
     <ProjectItem :proj="proj" v-for="proj in lastProjects"  :key="proj.id"/>
    </ul>
        </div>
    
    <CustomButton to="/projets" center label="Voir plus de projets" space-block/>
    </div>
</div>
</template>
<script setup lang='ts'>
import ProjectItem from '../projets/ProjectItem.vue';
import Loader from '../elements/Loader.vue';
import CustomButton from '../elements/CustomButton.vue';
/*  VARIABLES  */
const {getLastProjects} = useWordpressApi()

const { data: lastProjects, pending: loading } = await useAsyncData(
  'last-projects-component',
  () => getLastProjects()
)

/*  FUNCTIONS  */
</script>

<style lang="scss">
    .last-projects{
        padding-top: 50px;
 
        &__iframe{
            position: relative;
            overflow: hidden;
            height: 675px;
            @media screen and (max-width:1035px) {
                height: 443px;
            }
            iframe{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                @media screen and (max-width:1035px) {
                height: 445px;
                width: 790px;
            }
            }
        }
        &__list{
            margin-top: 2rem;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            list-style-type: none;
            padding: 0;
            gap: 1rem;

            .project-item{
                @media screen and (max-width:1035px) {
                   flex: auto;
                   width: 200px;
                   height: 200px;
                }
            }
            
        }
    }
</style>